import React from "react";
import { Breadcrumb, Space, Typography } from "antd";
import { Link, useNavigate } from "react-router-dom";

/**
 * AppBreadcrumb
 *
 * Props:
 *   items        - Array<{ label, path?, isDropdown?, dropdownComponent? }>
 *                  Last item is always rendered as plain text (position-based, not path-based).
 *   backTo       - explicit back-nav target; defaults to "/"
 *   showBack     - whether to render the leading "←" arrow; default true
 *   home         - when true, prepends a "Modulos → /" home item automatically; default true
 */
export default function AppBreadcrumb({
  items = [],
  backTo = "/",
  showBack = true,
  home = true,
}) {
  const navigate = useNavigate();

  const handleBack = () => navigate(backTo);

  // Optionally prepend home item
  const composed = home
    ? [{ label: "Modulos", path: "/" }, ...items]
    : items;

  const lastIndex = composed.length - 1;

  // Build antd v5 items array — put <Link> or dropdown inside `title`
  const antdItems = composed.map((item, index) => {
    // Last item is always plain text (current page) — position-based detection
    if (index === lastIndex) {
      return { title: item.label };
    }
    if (item.isDropdown) {
      return { title: item.dropdownComponent };
    }
    if (item.path) {
      return { title: <Link to={item.path}>{item.label}</Link> };
    }
    return { title: item.label };
  });

  return (
    <Space align="center" size={4}>
      {showBack && (
        <Typography.Link
          onClick={handleBack}
          style={{ marginRight: 4 }}
          aria-label="Volver"
        >
          ←
        </Typography.Link>
      )}
      <Breadcrumb items={antdItems} />
    </Space>
  );
}
